import { httpClient } from '@/utils/http-client';
class StreamService {
    httpClient;
    constructor() {
        this.httpClient = httpClient;
    }
    async getStreamInformation() {
        const response = await this.httpClient.get('/rtmp');
        return response.data;
    }
    async createStreamInformation(payload) {
        const response = await this.httpClient.post('/rtmp', payload);
        return response.data;
    }
    async updateStreamInformation(id, payload) {
        const response = await this.httpClient.patch('/rtmp/' + id, payload);
        return response.data;
    }
    async deleteStreamInformation(id) {
        const response = await this.httpClient.delete('/rtmp/' + id);
        return response.data;
    }
}
export default StreamService;
